import request from '../http';

/**
 * 开发工具 API
 * 对接后端 /dev/tools
 */

/** 获取数据统计 */
export const getStats = () =>
  request({ url: '/dev/tools/stats', method: 'get' });

/** 生成消耗测试数据 */
export const generateConsumption = (days) =>
  request({ url: '/dev/tools/generate-consumption', method: 'post', params: { days } });

/** 生成映射测试数据 */
export const generateMapping = (adsPerMaterial) =>
  request({ url: '/dev/tools/generate-mapping', method: 'post', params: { adsPerMaterial } });

/** 清除消耗数据 */
export const clearConsumption = () =>
  request({ url: '/dev/tools/consumption', method: 'delete' });

/** 清除映射数据 */
export const clearMapping = (onlyTestData) =>
  request({ url: '/dev/tools/mapping', method: 'delete', params: { onlyTestData } });

/** 清除所有测试数据 */
export const clearAll = () =>
  request({ url: '/dev/tools/all', method: 'delete' });

/** 生成广告结构（PG维表 + 素材映射，JSON body） */
export const generateStructure = (data) =>
  request({ url: '/dev/tools/generate-structure', method: 'post', data });

/** 基于当前账户扩展结构（系列/广告组/AD），不新建账户 */
export const expandStructureFromAccounts = (data) =>
  request({ url: '/dev/tools/expand-structure-from-accounts', method: 'post', data });

/** 生成消耗数据（CK + PG消耗，JSON body） */
export const generateInsights = (data) =>
  request({ url: '/dev/tools/generate-insights', method: 'post', data });

/** 清除 CK 数据（支持按日期区间或全量清除） */
export const clearCk = (params) =>
  request({ url: '/dev/tools/ck', method: 'delete', params });

/**
 * B2：从 PG fact_insights_daily 重建 CK（手动同步）
 * @param {Object} params - { startDate, endDate, level }
 *   level 可选：不传=全部重建；'campaign'/'adset'/'ad'=仅重建该维度
 */
export const rebuildCkFromPg = (params) =>
  request({ url: '/dev/tools/ck/rebuild-from-pg', method: 'post', params });

/** CK→PG 初始化：将 CK fact_insights_daily 迁移到 PG（首次/回填） */
export const initPgFromCk = (params) =>
  request({ url: '/dev/tools/pg/init-from-ck', method: 'post', params });

/** 执行素材消耗聚合：写入 PG + CK material_consumption_daily（初始化/手动触发）
 * @param {Object} params - { startDate, endDate } 可选，手动指定日期范围（yyyy-MM-dd）
 */
export const aggregateMaterialConsumption = (params) =>
  request({ url: '/dev/tools/aggregate-material-consumption', method: 'post', params });

/** 一键重建素材消耗：清除→广告结构→消耗→聚合（按正确顺序执行） */
export const rebuildMaterialConsumption = (data) =>
  request({ url: '/dev/tools/rebuild-material-consumption', method: 'post', data });

/** 生成测试素材（物理文件 + DB 记录） */
export const generateMaterials = (params) =>
  request({ url: '/dev/tools/generate-materials', method: 'post', params });

/** 清除测试素材（物理文件 + DB 记录） */
export const clearMaterials = (params) =>
  request({ url: '/dev/tools/materials', method: 'delete', params });

// ==================== 分步操作接口 ====================

/** 步骤1：仅生成映射（可选数据区间通过 coverage/count 控制）
 * @param {Object} params - { mappingCoverage, materialLimit, targetMappingCount, clearExisting }
 */
export const step1CreateMapping = (params) =>
  request({ url: '/dev/tools/step1-create-mapping', method: 'post', params });

/** 步骤2：仅生成 PG fact_insights_daily
 * @param {Object} data - { startDate, endDate, spendMin, spendMax, impressionsMin, impressionsMax, ... }
 */
export const step2GeneratePgInsights = (data) =>
  request({ url: '/dev/tools/step2-generate-pg-insights', method: 'post', data });

/** 步骤3：PG→CK 同步 + 素材消耗聚合
 * @param {Object} params - { startDate, endDate } 可选，不传则用 PG 日期范围
 */
export const step3SyncCkAndAggregate = (params) =>
  request({ url: '/dev/tools/step3-sync-ck-and-aggregate', method: 'post', params });

/** 从广告投放系统（zxwl_ads_backend）拉取数据同步到本地 PG
 * @param {Object} params - { startDate, endDate } 可选（yyyy-MM-dd），不传则默认近7天
 */
export const syncFromAdsBackend = (params) =>
  request({ url: '/dev/tools/sync-from-ads-backend', method: 'post', params });
